// extracted by mini-css-extract-plugin
export default {"svg":"UserNav_svg__AQNdl","link":"UserNav_link__YtNNn","container":"UserNav_container__QjR31"};